/**
 * @template K
 * @param {any} key
 * @template V
 * @param {any} value
 */
export default class Collection extends Map {
	toObject() {
		return Object.fromEntries(this.entries());
	}

	toArrayValues() {
		return [...this.values()];
	}

	filter(predicate) {
		return new Collection([...this].filter(predicate));
	}

	/**
	 *
	 * @param predicate
	 * @returns {V}
	 */
	find(predicate) {
		const result = [...this].find(predicate);
		if (result) {
			return result[1];
		}
		return undefined;
	}

	sort(predicate) {
		return new Collection([...this].sort(predicate));
	}

	length() {
		return this.size;
	}
}
